import api from "./api";

const roleService = {
  // Get all roles
  getRoles: async () => {
    const response = await api.get("/api/roles");
    return response.data;
  },

  // Get single role with assigned permissions
  getRoleById: async (id) => {
    const response = await api.get(`/api/roles/${id}`);
    return response.data;
  },

  // Get all available system permissions grouped by module
  getAllPermissions: async () => {
    const response = await api.get("/api/roles/permissions");
    return response.data;
  },

  // Create new custom role
  createRole: async (roleData) => {
    const response = await api.post("/api/roles", roleData);
    return response.data;
  },

  // Update existing role
  updateRole: async (id, roleData) => {
    const response = await api.put(`/api/roles/${id}`, roleData);
    return response.data;
  },

  // Delete custom role
  deleteRole: async (id) => {
    const response = await api.delete(`/api/roles/${id}`);
    return response.data;
  },

  // Get admin users with their assigned roles
  getUsersWithRoles: async () => {
    const response = await api.get("/api/roles/users");
    return response.data;
  },

  // Assign role to user
  assignRoleToUser: async (userId, roleId) => {
    const response = await api.post("/api/roles/assign-user", {
      user_id: userId,
      role_id: roleId,
    });
    return response.data;
  },
};

export default roleService;
